/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Welcome_Suggestion_Find_Answers_KnowledgeInputs */



/**
* | output |
* | --- |
* | "Where does our company knowledge live?" |
*
* @param {Uno_Welcome_Suggestion_Find_Answers_KnowledgeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_welcome_suggestion_find_answers_knowledge = /** @type {((inputs?: Uno_Welcome_Suggestion_Find_Answers_KnowledgeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Welcome_Suggestion_Find_Answers_KnowledgeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wo finde ich unser Unternehmenswissen?")
	return /** @type {LocalizedString} */ ("Where does our company knowledge live?")
});